import { CellDoubleClickedEvent, ICellRendererParams } from 'ag-grid-enterprise'
import { format } from 'date-fns'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { Feeds } from '@fortem-monorepo/web-sdk'

import { FeedsStatusCellRenderer } from '@/ag-grid/cell-renderers/FeedsStatusCellRenderer'

export const createCols = (
  dates: Date[],
  withFund = false,
  onCellDoubleClicked?: (e: CellDoubleClickedEvent<Feeds.FeedData>) => void,
) => {
  return createColDefs<Feeds.FeedData>([
    ...(withFund
      ? [
          {
            field: 'fund',
            suppressSizeToFit: true,
          },
        ]
      : []),
    {
      field: 'provider',
      rowGroup: true,
      hide: true,
      openByDefault: true,
      suppressSizeToFit: true,
    },
    {
      field: 'feed',
      rowGroup: withFund,
      hide: withFund,
      suppressSizeToFit: true,
    },
    ...dates
      .sort((a, b) => b.getTime() - a.getTime())
      .map(
        (date) =>
          ({
            field: toISO8601(date) as unknown as undefined,
            headerName: format(date, 'do MMM'),
            cellRenderer: (params: ICellRendererParams) => {
              return !params.node.group && <FeedsStatusCellRenderer {...params} />
            },
            suppressHeaderFilterButton: true,
            width: 80,
            // @ts-ignore
            onCellDoubleClicked,
            cellClassRules: {
              ['hover:bg-gray-100 cursor-pointer']: (params: any) => !!params?.value,
            },
          }) satisfies ReturnType<typeof createColDefs>[number],
      ),
  ])
}
